import React from "react";
import {
  ArrowDownOutlined,
  AudioFilled,
  BellFilled,
  DownOutlined,
  HistoryOutlined,
  LoginOutlined,
  LogoutOutlined,
  VideoCameraFilled,
  InstagramOutlined,
  YoutubeOutlined,
  FacebookOutlined,
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Dropdown,
  Modal,
  Button,
  Col,
  Row,
  Typography,
  Grid,
  Popover,
  Card,
  Badge,
  Empty,
  Spin,
  Avatar,
  Menu,
  Divider,
  Space,
  Drawer,
} from "antd";
import {
  StyledLink,
  StyledMenu,
  StyledMenu2,
  StyledMenuButton,
  StyledMenuButton2,
} from "./styles";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import History from "../History";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import UserConfig from "../Settings/UserConfigurations";
import { useKeycloak } from "@react-keycloak/web";
import { StyledLoginButton } from "../../Container/Auth/SignIn/styles";
import {
  clearNotifications,
  markNotificationAsRead,
} from "../../Redux/Slice/DataSlice";
import {
  uploadToInstagram,
  uploadToFacebook,
  uploadToYouTube,
} from "../../Redux/Slice/SocialMediaSlice";
import { keyframes, styled } from "styled-components";
import { getHistory } from "../../Redux/Slice/HistorySlice";
import { format } from "date-fns";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ThickSpinner = styled.div`
  width: 14px;
  height: 14px;
  border: 4px solid #ffffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: ${spinAnimation} 0.6s linear infinite;
`;

export const Header = () => {
  const [settingsModal, showSettingsModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [historyModal, showHistoryModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const [currentContent, setCurrentContent] = useState<any>({});
  const [isOpen, setIsOpen] = useState(false);
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);

  const { keycloak } = useKeycloak();
  const screens = useBreakpoint();

  const userEmail = keycloak?.idTokenParsed?.email;
  const userRoles = Array.isArray(
    keycloak?.resourceAccess?.medianestclient?.roles,
  )
    ? keycloak.resourceAccess.medianestclient.roles
    : [];

  const items = [
    {
      key: "history",
      label: "History",
      icon: <HistoryOutlined />,
      onClick: () => {
        setCurrentPage(1);
        showHistoryModal(true);
        dispatch(getHistory({ token: keycloak.token }));
      },
    },
    {
      key: "Divider",
      label: (
        <Divider
          style={{
            margin: 0,
            pointerEvents: "none",
            borderTop: "2px solid #d9d9d9",
          }}
        />
      ),
    },
    {
      key: "logout",
      label: "Log out",
      icon: <LogoutOutlined />,
      onClick: () => keycloak.logout({ redirectUri: window.location.origin }),
    },
  ];

  const handleSettingsModalCancel = () => {
    showSettingsModal(false);
  };

  const [scrolled, setScrolled] = useState(false);

  const { audioPath: audioResponse, loading: audioLoading } = useSelector(
    (state: any) => state.data.audioData,
  );
  const { videoPath: videoResponse, loading: videoLoading } = useSelector(
    (state: any) => state.data.videoData,
  );
  const { videoPath: captioned, loading: captionLoading } = useSelector(
    (state: any) => state.data.captionedNewsReelData,
  );
  const { loading: heygenLoading } = useSelector(
    (state: any) => state.data.heygenData,
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.2) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [visible, setVisible] = useState(false);

  const { notifications } = useSelector((state: any) => state.data.audioData);
  const { response: newsResponse } = useSelector(
    (state: any) => state.data.newsData,
  );
  const { response: articleResponse } = useSelector(
    (state: any) => state.data.generatedArticle,
  );
  const { response: announcementResponse } = useSelector(
    (state: any) => state.data.generatedAnnouncement,
  );
  const selectedNews = useSelector(
    (state: any) => state.news.selectedArticles || [],
  );
  const announcementLanguage = useSelector(
    (state: any) => state.data.generatedAnnouncement.language || "english",
  );
  const { instagramLoading, facebookLoading, youtubeLoading } = useSelector(
    (state: any) => state.socialMedia,
  );

  const normalizeLanguage = (value?: string) => {
    if (!value || typeof value !== "string") {
      return "english";
    }
    const normalized = value.toLowerCase();
    if (normalized.startsWith("ar")) return "arabic";
    if (normalized.startsWith("ur")) return "urdu";
    if (normalized.startsWith("en")) return "english";
    return "english";
  };

  const resolvedLanguage =
    location.pathname === "/Announcement"
      ? announcementLanguage || "english"
      : normalizeLanguage(selectedNews?.[0]?.language);

  const handleNotificationClick = (audio) => {
    setIsOpen(true);
    setCurrentContent(audio);
    setVisible(false);
  };

  const removeHtmlTags = (text) => {
    return text.replace(/<[^>]*>/g, "");
  };

  const resolveCaption = () => {
    if (location.pathname === "/Announcement" && announcementResponse) {
      return announcementResponse;
    }
    if (articleResponse) {
      return articleResponse;
    }
    if (newsResponse) {
      return newsResponse;
    }
    return "Check out this content!";
  };

  const handleInstagramUpload = () => {
    const caption = removeHtmlTags(resolveCaption());

    dispatch(
      uploadToInstagram({
        caption: caption,
        videoUrl: currentContent?.response,
        language: resolvedLanguage,
      }),
    );
  };

  const handleFacebookUpload = () => {
    const caption = removeHtmlTags(resolveCaption());

    dispatch(
      uploadToFacebook({
        caption: caption,
        videoUrl: currentContent?.response,
        language: resolvedLanguage,
      }),
    );
  };

  const handleYouTubeUpload = () => {
    const caption = removeHtmlTags(resolveCaption());

    dispatch(
      uploadToYouTube({
        caption: caption,
        videoUrl: currentContent?.response,
        language: resolvedLanguage,
      }),
    );
  };

  const handleBellClick = () => {
    setVisible(!visible);
    dispatch(clearNotifications());
  };
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };
  const displayNotifications = () => {
    notifications.forEach(() => {});
  };

  useEffect(() => {
    if (notifications.length > 0) {
      displayNotifications();
    }
  }, [notifications]);

  const audioRef = useRef(null);
  const videoRef = useRef(null);

  const handleModalClose = () => {
    setCurrentContent({});
    setIsOpen(false);

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const historyAudioRef = useRef(null);
  const historyVideoRef = useRef(null);

  const handleHistoryModalCancel = () => {
    showHistoryModal(false);

    if (historyAudioRef.current) {
      historyAudioRef.current.pause();
      historyAudioRef.current.currentTime = 0;
    }
    if (historyVideoRef.current) {
      historyVideoRef.current.pause();
      historyVideoRef.current.currentTime = 0;
    }
  };

  const markUnread = (notif) => {
    if (notif?.doc_id?.$oid) {
      dispatch(markNotificationAsRead(notif.doc_id.$oid));
    }
  };

  const MemoizedPopover = React.memo(Popover);

  return (
    <>
      {location.pathname === "/NewsList" ||
      location.pathname === "/UserProfile" ||
      location.pathname === "/News" ||
      location.pathname === "/Article" ||
      location.pathname === "/Announcement" ||
      location.pathname === "/terms-of-service" ||
      location.pathname === "/refund-policy" ||
      location.pathname === "/report-news" ||
      location.pathname === "/privacy-policy" ? (
        <>
          <Row style={{ zIndex: 1000 }}>
            <Col span={24} style={{ zIndex: 1 }}>
              <StyledMenu2 theme="dark" mode="horizontal">
                <Col
                  xs={{ span: 12, offset: 0 }}
                  sm={{ span: 10, offset: 1 }}
                  md={{ span: 10, offset: 1 }}
                  lg={{ span: 10, offset: 2 }}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: screens.xs ? "6px" : "12px",
                    paddingLeft: screens.xs ? "8px" : "0",
                  }}
                >
                  <StyledMenuButton type="text" key="home">
                    <StyledLink
                      style={{
                        fontSize: screens.xs ? "16px" : "22px",
                        fontWeight: "800",
                        color: "white",
                      }}
                      to="/"
                    >
                      <img
                        src="Logo@2x.png"
                        alt="Logo"
                        style={{
                          height: screens.xs ? "25px" : "35px",
                          width: "auto",
                        }}
                      />
                    </StyledLink>
                  </StyledMenuButton>
                  {/* {!screens.xs && ( */}
                  {/* // <span style={{ color: "white", fontSize: "20px" }}>|</span> */}
                  {/* )} */}
                  {/* <StyledMenuButton type="text" key="admn">
                    <StyledLink
                      style={{
                        fontSize: screens.xs ? "16px" : "22px",
                        fontWeight: "800",
                        color: "white",
                      }}
                      to="https://www.admn.ae/en/"
                    >
                      <img
                        src="admnlogo.png"
                        alt="Logo"
                        style={{ 
                          height: screens.xs ? "25px" : "35px", 
                          width: "auto" 
                        }}
                      />
                    </StyledLink>
                  </StyledMenuButton> */}
                </Col>

                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    paddingRight: screens.xs ? "8px" : "0",
                  }}
                >
                  {screens.md || screens.lg || screens.xl || screens.xxl ? (
                    <>
                      <MemoizedPopover
                      title="Notifications"
                      trigger="hover"
                      open={visible}
                      onOpenChange={handleVisibleChange}
                      content={
                        <div
                          style={{
                            width: screens.xs ? 280 : 300,
                            maxHeight: "500px",
                            overflowY: "auto",
                          }}
                        >
                          {notifications.length === 0 ? (
                            <div
                              style={{ textAlign: "center", padding: "10px" }}
                            >
                              <Empty
                                description={
                                  <span style={{ color: "#005461" }}>
                                    No Notifications
                                  </span>
                                }
                              />
                            </div>
                          ) : (
                            notifications
                              .slice()
                              .reverse()
                              .map((notification, index) => {
                                const generatedTime =
                                  notification.generatedTime;
                                const timeZone =
                                  Intl.DateTimeFormat().resolvedOptions()
                                    .timeZone;
                                // const localTime = generatedTime ? utcToZonedTime(new Date(generatedTime), timeZone) : null;

                                const formattedTime = generatedTime
                                  ? format(new Date(generatedTime), "h:mm a")
                                  : "";

                                const formattedDate = generatedTime
                                  ? format(
                                      new Date(generatedTime),
                                      "dd-MM-yyyy",
                                    )
                                  : "";
                                return (
                                  <Card
                                    key={index}
                                    size="small"
                                    style={{
                                      marginBottom: 5,
                                      cursor: "pointer",
                                      borderColor: "transparent",
                                      borderBottom: "1px solid lightgrey",
                                      borderLeft: notification.audio?.read
                                        ? "none"
                                        : "2px solid red",
                                      background: "whitesmoke",
                                      boxShadow:
                                        " 0px 2px 5px rgba(0, 0, 0, 0.1)",
                                      borderRadius: "0px",
                                      // height: "80px",
                                    }}
                                    onClick={() => {
                                      handleNotificationClick(
                                        notification?.audio,
                                      );
                                      markUnread(notification?.audio);
                                    }}
                                  >
                                    {/* <Row
                                      justify={"start"}
                                      style={{
                                        display: "flex",
                                        height: "100%",
                                      }}
                                    > */}
                                    <p
                                      style={{
                                        margin: "0",
                                        display: "flex",
                                        alignContent: "start",
                                        alignItems: "center",
                                        justifyContent: "start",
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        color: "#de283b",
                                      }}
                                    >
                                      {notification?.audio?.gen_type ===
                                      "audio" ? (
                                        <>
                                          <Col
                                            xs={{ span: 6 }}
                                            lg={{ span: 4 }}
                                          >
                                            <AudioFilled
                                              style={{
                                                color: "#005461",
                                                fontSize: screens.xs
                                                  ? "24px"
                                                  : "32px",
                                                alignContent: "center",
                                              }}
                                            />
                                          </Col>
                                          <Col
                                            xs={{ span: 18 }}
                                            lg={{ span: 16 }}
                                            style={{
                                              display: "grid",
                                              justifyContent: "start",
                                              marginLeft: screens.xs
                                                ? "5px"
                                                : "10px",
                                            }}
                                          >
                                            <Text
                                              style={{
                                                color: "#005461",
                                                fontSize: screens.xs
                                                  ? "14px"
                                                  : "16px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              {" "}
                                              Audio Generated.
                                            </Text>
                                            <Text
                                              style={{
                                                color: "black",
                                                fontSize: screens.xs
                                                  ? "11px"
                                                  : "12px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              Time: {formattedTime}
                                            </Text>
                                            <Text
                                              style={{
                                                color: "black",
                                                fontSize: screens.xs
                                                  ? "11px"
                                                  : "12px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              Date: {formattedDate}
                                            </Text>
                                          </Col>
                                        </>
                                      ) : (
                                        <>
                                          <Col
                                            xs={{ span: 6 }}
                                            lg={{ span: 4 }}
                                          >
                                            <VideoCameraFilled
                                              style={{
                                                color: "#005461",
                                                fontSize: screens.xs
                                                  ? "24px"
                                                  : "32px",
                                                alignContent: "center",
                                              }}
                                            />
                                          </Col>
                                          <Col
                                            xs={{ span: 18 }}
                                            lg={{ span: 16 }}
                                            style={{
                                              display: "grid",
                                              justifyContent: "start",
                                              marginLeft: screens.xs
                                                ? "5px"
                                                : "10px",
                                            }}
                                          >
                                            <Text
                                              style={{
                                                color: "#005461",
                                                fontSize: screens.xs
                                                  ? "14px"
                                                  : "16px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              {" "}
                                              Video Generated.
                                            </Text>
                                            <Text
                                              style={{
                                                color: "black",
                                                fontSize: screens.xs
                                                  ? "11px"
                                                  : "12px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              Time:{formattedTime}
                                            </Text>
                                            <Text
                                              style={{
                                                color: "black",
                                                fontSize: screens.xs
                                                  ? "11px"
                                                  : "12px",
                                                fontFamily: "Inter",
                                              }}
                                            >
                                              Date:
                                              {formattedDate}
                                            </Text>
                                          </Col>
                                        </>
                                      )}
                                      {/* Click to Play{" "}
                                        {`${
                                          notification?.audio?.gen_type ===
                                          "audio"
                                            ? "Audio"
                                            : "Video"
                                        }`}
                                         */}
                                    </p>
                                    {/* </Row> */}
                                  </Card>
                                );
                              })
                          )}
                        </div>
                      }
                    >
                      {keycloak.authenticated &&
                        (audioLoading ||
                        videoLoading ||
                        heygenLoading ||
                        captionLoading ? (
                          <Badge
                            count={
                              <Spin indicator={<ThickSpinner />} size="small" />
                            }
                            offset={screens.xs ? [-1, 1] : [-2, 2]}
                          >
                            <BellFilled
                              style={{
                                fontSize: screens.xs ? "18px" : "24px",
                                color: "white",
                                cursor: "pointer",
                              }}
                              onClick={() => setVisible(!visible)}
                            />
                          </Badge>
                        ) : notifications.filter(
                            (notification) => !notification.audio?.read,
                          ).length > 0 ? (
                          <Badge
                            size="small"
                            count={
                              notifications.filter(
                                (notification) => !notification.audio?.read,
                              ).length
                            }
                            offset={screens.xs ? [-1, 1] : [-2, 2]}
                          >
                            <BellFilled
                              style={{
                                fontSize: screens.xs ? "18px" : "24px",
                                color: "white",
                                cursor: "pointer",
                              }}
                              onClick={() => setVisible(!visible)}
                            />
                          </Badge>
                        ) : (
                          <BellFilled
                            style={{
                              fontSize: screens.xs ? "18px" : "24px",
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => setVisible(!visible)}
                          />
                        ))}
                    </MemoizedPopover>
                    <div
                      style={{
                        width: screens.xs ? "auto" : "210px",
                        marginLeft: screens.xs ? "8px" : "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {keycloak.authenticated ? (
                        <Dropdown
                          placement="bottomRight"
                          trigger={["click"]}
                          dropdownRender={() => (
                            <Card style={{ width: 300, borderRadius: 8 }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: 12,
                                }}
                              >
                                <Avatar
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    backgroundColor: "#fde3cf",
                                    color: "#f56a00",
                                    marginRight: 8,
                                  }}
                                  size={48}
                                >
                                  {keycloak?.idTokenParsed?.preferred_username
                                    ?.charAt(0)
                                    .toUpperCase()}
                                </Avatar>
                                <div>
                                  <Title level={5} style={{ margin: 0 }}>
                                    {
                                      keycloak?.idTokenParsed
                                        ?.preferred_username
                                    }
                                  </Title>
                                  <Text type="secondary">
                                    {keycloak?.idTokenParsed?.email}
                                  </Text>
                                </div>
                              </div>

                              <Menu
                                items={items}
                                style={{ border: "none", boxShadow: "none" }}
                              />
                            </Card>
                          )}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <Avatar
                              style={{
                                backgroundColor: "#fde3cf",
                                color: "#f56a00",
                                marginRight: screens.xs ? 4 : 8,
                                height: screens.xs ? "32px" : "42px",
                                width: screens.xs ? "32px" : "42px",
                                fontSize: screens.xs ? "14px" : "18px",
                              }}
                            >
                              {keycloak?.idTokenParsed?.preferred_username
                                ?.charAt(0)
                                .toUpperCase()}
                              {!screens.xs && (
                                <DownOutlined
                                  style={{ fontSize: "10px", color: "red" }}
                                />
                              )}
                            </Avatar>
                          </div>
                        </Dropdown>
                      ) : (
                        <StyledMenu
                          scrolled={scrolled}
                          style={{
                            justifyContent: screens.xs ? "start" : "center",
                            alignItems: "center",
                            height: "50px",
                          }}
                          theme="dark"
                          mode="horizontal"
                        >
                          <StyledLoginButton
                            style={{
                              width: screens.xs ? "40px" : "120px",
                              fontSize: "20px",
                              padding: screens.xs ? "20px" : "24px",
                              borderRadius: screens.xs ? "20px" : "5px",
                            }}
                            onClick={() => keycloak.login()}
                            type="primary"
                          >
                            {screens.xs ? <LoginOutlined /> : "Login"}
                          </StyledLoginButton>
                        </StyledMenu>
                      )}
                    </div>
                    <Modal
                      title="Generated Media"
                      open={isOpen}
                      onCancel={() => {
                        setCurrentContent({});
                        handleModalClose();
                      }}
                      footer={null}
                      centered
                      width={
                        currentContent?.gen_type === "video" ? "auto" : 520
                      }
                      style={{
                        maxWidth:
                          currentContent?.gen_type === "video"
                            ? screens.xs
                              ? "95vw"
                              : "90vw"
                            : undefined,
                      }}
                      bodyStyle={{
                        padding:
                          currentContent?.gen_type === "video"
                            ? "12px"
                            : "24px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {currentContent?.gen_type === "audio" ? (
                        <audio
                          ref={audioRef}
                          controls
                          src={currentContent?.response}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                          }}
                        >
                          Your browser does not support the audio tag.
                        </audio>
                      ) : (
                        <video
                          ref={videoRef}
                          controls
                          src={currentContent?.response}
                          style={{
                            maxWidth: "100%",
                            maxHeight: screens.xs ? "70vh" : "80vh",
                            width: "auto",
                            height: "auto",
                            display: "block",
                          }}
                        >
                          Your browser does not support the video tag.
                        </video>
                      )}

                      {currentContent?.gen_type?.toLowerCase() !== "audio" && (
                        <>
                          <Divider
                            style={{ margin: "16px 0", width: "100%" }}
                          />

                          <div style={{ textAlign: "center", width: "100%" }}>
                            <Text
                              strong
                              style={{ marginBottom: "12px", display: "block" }}
                            >
                              Upload to Social Media
                            </Text>
                            <Space
                              size="middle"
                              wrap
                              style={{ justifyContent: "center" }}
                            >
                              <Button
                                type="primary"
                                icon={<InstagramOutlined />}
                                onClick={handleInstagramUpload}
                                loading={instagramLoading}
                                style={{
                                  background:
                                    "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                                  border: "none",
                                }}
                              >
                                Instagram
                              </Button>
                              <Button
                                type="primary"
                                icon={<FacebookOutlined />}
                                onClick={handleFacebookUpload}
                                loading={facebookLoading}
                                style={{
                                  background: "#1877F2",
                                  border: "none",
                                }}
                              >
                                Facebook
                              </Button>
                              <Button
                                type="primary"
                                icon={<YoutubeOutlined />}
                                onClick={handleYouTubeUpload}
                                loading={youtubeLoading}
                                danger
                                style={{
                                  background: "#FF0000",
                                  border: "none",
                                }}
                              >
                                YouTube
                              </Button>
                            </Space>
                          </div>
                        </>
                      )}
                    </Modal>
                    </>
                  ) : (
                    <Button
                      type="text"
                      icon={<MenuOutlined />}
                      onClick={() => setDrawerOpen(true)}
                      style={{
                        fontSize: "24px",
                        color: "white",
                        height: "40px",
                        width: "40px",
                      }}
                    />
                  )}
                </Col>

                <Modal
                  visible={settingsModal}
                  onCancel={handleSettingsModalCancel}
                  footer={null}
                  style={{ minWidth: "1000px" }}
                >
                  <UserConfig />
                </Modal>

                <Modal
                  open={historyModal}
                  onCancel={handleHistoryModalCancel}
                  footer={null}
                  style={{ minWidth: "60%", height: "700px" }}
                >
                  <History
                    historyAudioRef={historyAudioRef}
                    historyVideoRef={historyVideoRef}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </Modal>

                <Drawer
                  title="Menu"
                  placement="right"
                  onClose={() => setDrawerOpen(false)}
                  open={drawerOpen}
                  width={280}
                  styles={{
                    header: {
                      background: "white",
                      color: "#005461",
                      borderBottom: "1px solid #e8e8e8",
                    },
                    body: {
                      padding: 0,
                      background: "white",
                    },
                  }}
                  closeIcon={<CloseOutlined style={{ color: "#005461" }} />}
                >
                  <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    {keycloak.authenticated && (
                      <>
                        <div
                          style={{
                            padding: "20px",
                            borderBottom: "1px solid #e8e8e8",
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <Avatar
                            style={{
                              backgroundColor: "#fde3cf",
                              color: "#f56a00",
                              width: "48px",
                              height: "48px",
                              fontSize: "20px",
                            }}
                          >
                            {keycloak?.idTokenParsed?.preferred_username
                              ?.charAt(0)
                              .toUpperCase()}
                          </Avatar>
                          <div>
                            <div style={{ color: "#005461", fontWeight: 600, fontSize: "16px" }}>
                              {keycloak?.idTokenParsed?.preferred_username}
                            </div>
                            <div style={{ color: "#666", fontSize: "12px" }}>
                              {keycloak?.idTokenParsed?.email}
                            </div>
                          </div>
                        </div>

                        <div style={{ padding: "12px 0" }}>
                          <Button
                            type="text"
                            icon={<BellFilled />}
                            onClick={() => {
                              setNotificationsModalOpen(true);
                              setDrawerOpen(false);
                            }}
                            style={{
                              width: "100%",
                              height: "48px",
                              textAlign: "left",
                              color: "#005461",
                              fontSize: "16px",
                              paddingLeft: "20px",
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <Badge
                              count={
                                notifications.filter((notification) => !notification.audio?.read)
                                  .length
                              }
                              offset={[10, 0]}
                            >
                              Notifications
                            </Badge>
                          </Button>

                          <Button
                            type="text"
                            icon={<HistoryOutlined />}
                            onClick={() => {
                              setCurrentPage(1);
                              showHistoryModal(true);
                              dispatch(getHistory({ token: keycloak.token }));
                              setDrawerOpen(false);
                            }}
                            style={{
                              width: "100%",
                              height: "48px",
                              textAlign: "left",
                              color: "#005461",
                              fontSize: "16px",
                              paddingLeft: "20px",
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            History
                          </Button>
                        </div>

                        <Divider style={{ margin: "0", borderColor: "#e8e8e8" }} />
                      </>
                    )}

                    <div style={{ flex: 1 }} />

                    <div style={{ padding: "20px" }}>
                      <Button
                        style={{
                          width: "100%",
                          height: "48px",
                          fontSize: "18px",
                          background: "transparent",
                          border: "1px solid #005461",
                          color: "#005461",
                        }}
                        onClick={() => {
                          if (keycloak.authenticated) {
                            keycloak.logout({ redirectUri: window.location.origin });
                          } else {
                            keycloak.login();
                          }
                          setDrawerOpen(false);
                        }}
                        icon={keycloak.authenticated ? <LogoutOutlined /> : <LoginOutlined />}
                      >
                        {keycloak.authenticated ? "Logout" : "Login"}
                      </Button>
                    </div>
                  </div>
                </Drawer>

                {/* Notifications Modal for Small Screens */}
                <Modal
                  title="Notifications"
                  open={notificationsModalOpen}
                  onCancel={() => {
                    setNotificationsModalOpen(false);
                    dispatch(clearNotifications());
                  }}
                  footer={null}
                  width={screens.xs ? "95%" : 400}
                  bodyStyle={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    padding: "12px",
                  }}
                >
                  {notifications.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <Empty
                        description={
                          <span style={{ color: "#005461" }}>No Notifications</span>
                        }
                      />
                    </div>
                  ) : (
                    notifications
                      .slice()
                      .reverse()
                      .map((notification, index) => {
                        const generatedTime = notification.generatedTime;
                        const formattedTime = generatedTime
                          ? format(new Date(generatedTime), "h:mm a")
                          : "";
                        const formattedDate = generatedTime
                          ? format(new Date(generatedTime), "dd-MM-yyyy")
                          : "";

                        return (
                          <Card
                            key={index}
                            size="small"
                            style={{
                              marginBottom: 8,
                              cursor: "pointer",
                              borderColor: "transparent",
                              borderBottom: "1px solid lightgrey",
                              borderLeft: notification.audio?.read
                                ? "none"
                                : "2px solid red",
                              background: "whitesmoke",
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                              borderRadius: "0px",
                            }}
                            onClick={() => {
                              handleNotificationClick(notification?.audio);
                              markUnread(notification?.audio);
                              setNotificationsModalOpen(false);
                            }}
                          >
                            <p
                              style={{
                                margin: "0",
                                display: "flex",
                                alignContent: "start",
                                alignItems: "center",
                                justifyContent: "start",
                                fontWeight: "bold",
                                fontSize: "16px",
                                color: "#de283b",
                              }}
                            >
                              {notification?.audio?.gen_type === "audio" ? (
                                <>
                                  <Col xs={{ span: 6 }} lg={{ span: 4 }}>
                                    <AudioFilled
                                      style={{
                                        color: "#005461",
                                        fontSize: "24px",
                                        alignContent: "center",
                                      }}
                                    />
                                  </Col>
                                  <Col
                                    xs={{ span: 18 }}
                                    lg={{ span: 16 }}
                                    style={{
                                      display: "grid",
                                      justifyContent: "start",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    <Text
                                      style={{
                                        color: "#005461",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Audio Generated.
                                    </Text>
                                    <Text
                                      style={{
                                        color: "black",
                                        fontSize: "11px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Time: {formattedTime}
                                    </Text>
                                    <Text
                                      style={{
                                        color: "black",
                                        fontSize: "11px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Date: {formattedDate}
                                    </Text>
                                  </Col>
                                </>
                              ) : (
                                <>
                                  <Col xs={{ span: 6 }} lg={{ span: 4 }}>
                                    <VideoCameraFilled
                                      style={{
                                        color: "#005461",
                                        fontSize: "24px",
                                        alignContent: "center",
                                      }}
                                    />
                                  </Col>
                                  <Col
                                    xs={{ span: 18 }}
                                    lg={{ span: 16 }}
                                    style={{
                                      display: "grid",
                                      justifyContent: "start",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    <Text
                                      style={{
                                        color: "#005461",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Video Generated.
                                    </Text>
                                    <Text
                                      style={{
                                        color: "black",
                                        fontSize: "11px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Time: {formattedTime}
                                    </Text>
                                    <Text
                                      style={{
                                        color: "black",
                                        fontSize: "11px",
                                        fontFamily: "Inter",
                                      }}
                                    >
                                      Date: {formattedDate}
                                    </Text>
                                  </Col>
                                </>
                              )}
                            </p>
                          </Card>
                        );
                      })
                  )}
                </Modal>
              </StyledMenu2>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row style={{ width: "100%" }}>
            <Col
              style={{ zIndex: 1 }}
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
            >
              <StyledMenu
                scrolled={scrolled}
                theme="dark"
                mode="horizontal"
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                <StyledLink
                  scrolled={scrolled}
                  to="/"
                  style={{ fontSize: "28px", fontWeight: "800" }}
                >
                  <img
                    src="Logo@2x.png"
                    alt="Logo"
                    style={{
                      height: screens.xs ? "40px" : "65px",
                      width: "auto",
                    }}
                  />
                </StyledLink>

                {/* <span style={{ color: "white", fontSize: "24px" }}>|</span> */}
                {/* <StyledMenuButton2 type="text">
                  <StyledLink
                    scrolled={scrolled}
                    to="https://www.admn.ae/en/"
                    style={{ fontSize: "28px", fontWeight: "800" }}
                  >
                    <img
                      src="admnlogo.png"
                      alt="Logo"
                      style={{ height: "35px", width: "auto" }}
                    />
                  </StyledLink>
                </StyledMenuButton2> */}
              </StyledMenu>
            </Col>
            {screens.md || screens.lg || screens.xl || screens.xxl ? (
              <Col
                style={{
                  zIndex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
              >
                <StyledMenu
                  scrolled={scrolled}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  theme="dark"
                  mode="horizontal"
                  className="centered-menu"
                >
                  <StyledMenuButton2
                    onClick={() => scrollToElement("Hero")}
                    type="text"
                    key="home"
                  >
                    <StyledLink scrolled={scrolled} to="/">
                      Home
                    </StyledLink>
                  </StyledMenuButton2>
                  <StyledMenuButton2
                    type="text"
                    onClick={() => scrollToElement("featureRow")}
                    key="features"
                  >
                    <StyledLink scrolled={scrolled} to="/">
                      Features
                    </StyledLink>
                  </StyledMenuButton2>
                  <StyledMenuButton2
                    type="text"
                    onClick={() => scrollToElement("FAQS")}
                    key="faq"
                  >
                    <StyledLink scrolled={scrolled} to="/">
                      FAQs
                    </StyledLink>
                  </StyledMenuButton2>
                  <StyledMenuButton2
                    type="text"
                    onClick={() => scrollToElement("Contact")}
                    key="contact"
                  >
                    <StyledLink scrolled={scrolled} to="/">
                      Contact Us
                    </StyledLink>
                  </StyledMenuButton2>
                </StyledMenu>
              </Col>
            ) : null}
            <Col
              style={{ zIndex: 1 }}
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
            >
              <StyledMenu
                scrolled={scrolled}
                style={{
                  justifyContent: screens.xs ? "end" : "center",
                  alignItems: "center",
                }}
                theme="dark"
                mode="horizontal"
              >
                {screens.md || screens.lg || screens.xl || screens.xxl ? (
                  <Button
                    style={{
                      marginLeft: "10px",
                      width: "150px",
                      height: "50px",
                      fontSize: "20px",
                      background: "transparent",
                      border: "1px solid white",
                      color: "white",
                      borderRadius: "5px",
                    }}
                    onClick={() =>
                      keycloak.authenticated
                        ? keycloak.logout({ redirectUri: window.location.origin })
                        : keycloak.login()
                    }
                    icon={keycloak.authenticated ? <LogoutOutlined /> : <LoginOutlined />}
                  >
                    {keycloak.authenticated ? "Logout" : "Login"}
                  </Button>
                ) : (
                  <Button
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setDrawerOpen(true)}
                    style={{
                      fontSize: "24px",
                      color: scrolled ? "white" : "white",
                      height: "40px",
                      width: "40px",
                    }}
                  />
                )}
              </StyledMenu>
            </Col>
          </Row>

          <Drawer
            title="Menu"
            placement="right"
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            width={280}
            styles={{
              header: {
                background: "white",
                color: "#005461",
                borderBottom: "1px solid #e8e8e8",
              },
              body: {
                padding: 0,
                background: "white",
              },
            }}
            closeIcon={<CloseOutlined style={{ color: "#005461" }} />}
          >
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <div style={{ padding: "12px 0" }}>
                <Button
                  type="text"
                  onClick={() => {
                    scrollToElement("Hero");
                    setDrawerOpen(false);
                  }}
                  style={{
                    width: "100%",
                    height: "48px",
                    textAlign: "left",
                    color: "#005461",
                    fontSize: "16px",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  Home
                </Button>

                <Button
                  type="text"
                  onClick={() => {
                    scrollToElement("featureRow");
                    setDrawerOpen(false);
                  }}
                  style={{
                    width: "100%",
                    height: "48px",
                    textAlign: "left",
                    color: "#005461",
                    fontSize: "16px",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  Features
                </Button>

                <Button
                  type="text"
                  onClick={() => {
                    scrollToElement("FAQS");
                    setDrawerOpen(false);
                  }}
                  style={{
                    width: "100%",
                    height: "48px",
                    textAlign: "left",
                    color: "#005461",
                    fontSize: "16px",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  FAQs
                </Button>

                <Button
                  type="text"
                  onClick={() => {
                    scrollToElement("Contact");
                    setDrawerOpen(false);
                  }}
                  style={{
                    width: "100%",
                    height: "48px",
                    textAlign: "left",
                    color: "#005461",
                    fontSize: "16px",
                    paddingLeft: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  Contact Us
                </Button>
              </div>

              <Divider style={{ margin: "0", borderColor: "#e8e8e8" }} />

              <div style={{ flex: 1 }} />

              <div style={{ padding: "20px" }}>
                <Button
                  style={{
                    width: "100%",
                    height: "48px",
                    fontSize: "18px",
                    background: "transparent",
                    border: "1px solid #005461",
                    color: "#005461",
                  }}
                  onClick={() => {
                    if (keycloak.authenticated) {
                      keycloak.logout({ redirectUri: window.location.origin });
                    } else {
                      keycloak.login();
                    }
                    setDrawerOpen(false);
                  }}
                  icon={keycloak.authenticated ? <LogoutOutlined /> : <LoginOutlined />}
                >
                  {keycloak.authenticated ? "Logout" : "Login"}
                </Button>
              </div>
            </div>
          </Drawer>
          {/* <Modal
            visible={settingsModal}
            onCancel={handleSettingsModalCancel}
            footer={null}
            style={{ minWidth: "1000px" }}
          >
            <SettingsTab /> 
          </Modal> */}

          {/* <Modal
            visible={historyModal}
            onCancel={handleHistoryModalCancel}
            footer={null}
            style={{ minWidth: "60%", maxHeight: '80vh', overflowY: 'auto'}}
          >
            <History modelVisible={historyModal} />
          </Modal> */}
        </>
      )}
    </>
  );
};
